import axios from "axios";
import React, { useState, useEffect } from "react";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";
import { API_Link, validateHeader } from "../commons/Constants";

const AdminReviewTypeListingComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [reviewTypes, setReviewTypes] = useState([]);
  const users = JSON.parse(localStorage.getItem("user"));
  const token = users.token;
  const MD5hash = validateHeader();

  // getReviewTypes
  const getReviewTypes = () => {
    setIsLoading(true);
    var config = {
      method: "get",
      url: `${API_Link}getReviewTypes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setReviewTypes(resData.data.reviewTypes);
        setIsLoading(false);

        //   console.log(resData.data.reviewTypes)
      })
      .catch(function (error) {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getReviewTypes();
  }, []);

  return (
    <div className="page--content ">
      <div className="row sticky-title align-items-center">
        <div className="col-md-6 col-lg-6">
          <h1 className="page--heading ">Review Type Listing</h1>
        </div>
      </div>
      <div className="row">
        <div className="padding-table ">
          <div className="table--template">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th></th>
                  {/* <td>Action</td> */}
                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  reviewTypes &&
                  reviewTypes?.map((type, index) => (
                    <tr>
                      <td>{index + 1} </td>
                      <td>
                        {type?.type.charAt(0).toUpperCase() +
                          type.type.slice(1)}
                      </td>
                      <td> {type?.description}</td>
                      <td></td>
                      {/* <td>
                        <Link to='' className='tem--add--btn'>
                          Edit
                        </Link>
                      </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="role-listing-loader d-flex">
                <Loader2 />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReviewTypeListingComponent;
